<template>
    <div>
        <dx-button
        class="btn-show-sidebar"
        :icon="sideNavOpened ? arrowLeftIcon : folderIcon"
        height="75px"
        width="75px"
        @click="toggleSideNav()"
        />
        <div class="side-nav" :class="{'is-active': isTreeListVisible, 'toggle-sidenav-on': sideNavOpened}">
            <div @click="sideNavOpened = !sideNavOpened;">
                <router-link class="side-nav-link" :to="{ name: 'workflow.index.taskgrid',  params: { gridSymbol: 'alltasks' }}">
                {{$t('processMenu.myTasks')}}
                </router-link>
            </div>
            <folder-list @linkClicked="sideNavOpened = !sideNavOpened;"></folder-list>    
        </div>
    </div>
</template>
<script>
    import localMessages from "../../locales";
    import FolderList from "./FolderList";
    import DxButton from "devextreme-vue/button";
    import "./SideNav.scss";
    import { mapState } from 'vuex';
    export default {
        name: "container",
        props: ["componentConfig"],
        data() {
            return {
                editPopupVisible: true,
                arrowRightIcon: "fas fa-angle-right",
                arrowLeftIcon: "fas fa-angle-left",
                folderIcon: "fas fa-folder-open",
                sideNavOpened: false
            }
        },
        computed: {
            ...mapState({ isTreeListVisible: state => state.isTreeListVisible }),
        },
        created() {
            this.sideNavOpened = false;
        },
        methods: {
            toggleSideNav() {
                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                this.sideNavOpened = !this.sideNavOpened;
            },
        },
        components: {
            FolderList,
            DxButton
        },
         i18n: {
            messages: localMessages.messages,
        }
    };
</script>
